@media (max-width: 360px) {
  .header {
    --nav-padding: 4px;
    --nav-gap: 0px;
  }
}
